import cookieManager from '../../../../utils/cookieManager';
import axios from '@/enhancers/axios';
import GeneralLedgerActions from '../../../../reducers/modules/report/general-ledger/actions';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { Navigate } from 'react-router-dom';

const MySwal = withReactContent(Swal)
const url=process.env.REST_URL +'report/general-ledger'

export default class GeneralLedgerMiddleware {

  static create(params){
    return (dispatch) => {
      dispatch(GeneralLedgerActions.create());
    };
  }

  static update(params){
    return (dispatch) => {
      GeneralLedgerMiddleware.showOne(dispatch, params);
      dispatch(GeneralLedgerActions.update());
    };
  }
  static resetList(){
    return (dispatch) => {
        dispatch(GeneralLedgerActions.resetList());
      };
  }
  static list(params){
      return (dispatch) => {
          dispatch(GeneralLedgerActions.process());
          GeneralLedgerMiddleware.showlist(dispatch, params);
        };
  }
  static showExcel(params){
    return (dispatch) => {
        dispatch(GeneralLedgerActions.process());
        GeneralLedgerMiddleware.beforeShowExcel(dispatch, params);
      };
}

  static beforeShowExcel(dispatch, params) {
 
  } 

  static listing(params){
    return (dispatch) => {
        dispatch(GeneralLedgerActions.process());
        GeneralLedgerMiddleware.showlisting(dispatch, params);
      };
}
  static reset(){
    return (dispatch) => {
        dispatch(GeneralLedgerActions.reset());
      };
}
  static getOne(params){
    return (dispatch) => {
        dispatch(GeneralLedgerActions.view());
        GeneralLedgerMiddleware.showOne(dispatch, params);
      };
  }

  static beforeSaveNew(post,search){
    return (dispatch) => {
        dispatch(GeneralLedgerActions.submit());
        GeneralLedgerMiddleware.saveNew(dispatch, post,search);
      };
  }
  static beforeSaveUpdate(post,params){
    return (dispatch) => {
        dispatch(GeneralLedgerActions.submit());
        GeneralLedgerMiddleware.saveUpdate(dispatch, params, post);
      };
  }
  static beforeDelete(id,params){
    return (dispatch) => {
        dispatch(GeneralLedgerMiddleware.delete());
        GeneralLedgerMiddleware.delete(dispatch,params,id);
      };
  }

  static getToken(){
      return cookieManager.getUserToken();
  }

  static getHelper(params=null){
    return (dispatch) => {
      GeneralLedgerMiddleware.showHelper(dispatch,params);
      };
  }

  static getPrint(params) {
    return (dispatch) => {
      dispatch(GeneralLedgerActions.beforePrint());
      GeneralLedgerMiddleware.showPrint(dispatch, params);
    };
  }

  static showPrint(dispatch, params) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${GeneralLedgerMiddleware.getToken()}`,
      },
      url: process.env.REST_URL +'report/general-ledger/print',
      responseType: "json",
      data:params
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(GeneralLedgerActions.print(response.data.result));
        }
      })
      .catch((error) => {
        GeneralLedgerMiddleware.alertHendler(dispatch, error);
      });
  }
 

 
  static showHelper(dispatch,params){
    axios({
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${GeneralLedgerMiddleware.getToken()}`
        },
        url:process.env.REST_URL+'helper/get-helper-general-ledger' ,
        responseType: 'json',
        params:params
      })
      .then((response) => {
        
        if (response && response.status === 200 && response.data) {
          dispatch(GeneralLedgerActions.helper(response.data.result));
        }
      })
      .catch((error) => {
        GeneralLedgerMiddleware.alertHendler(dispatch,error)
      });
  }

  static showlist(dispatch, params){
      axios({
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${GeneralLedgerMiddleware.getToken()}`
          },
          url: url,
          responseType: 'json',
          params:params
        })
        .then((response) => {
          
          if (response && response.status === 200 && response.data) {
            dispatch(GeneralLedgerActions.list(response.data.result));
          }
        })
        .catch((error) => {
          GeneralLedgerMiddleware.alertHendler(dispatch,error)
        });
  }

  static showlisting(dispatch, params){
    axios({
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${GeneralLedgerMiddleware.getToken()}`
        },
        url: url,
        responseType: 'json',
        params:params
      })
      .then((response) => {
        
        if (response && response.status === 200 && response.data) {
          dispatch(GeneralLedgerActions.list(response.data.result));
        }
      })
      .catch((error) => {
        GeneralLedgerMiddleware.alertHendler(dispatch,error)
      });
}

  static showOne(dispatch, params){
    axios({
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${GeneralLedgerMiddleware.getToken()}`
        },
        url: url +'/'+params,
        responseType: 'json'
      })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(GeneralLedgerActions.view(response.data.result));
        }
      })
      .catch((error) => {
        GeneralLedgerMiddleware.alertHendler(dispatch,error)
      });
  }

  static delete(dispatch, params,id){
    axios({
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${GeneralLedgerMiddleware.getToken()}`
        },
        url: url +'/'+id,
        responseType: 'json'
      })
      .then((response) => {
       
        if (response && response.status === 200 && response.data) {
          MySwal.close()
          dispatch(GeneralLedgerActions.process(),GeneralLedgerMiddleware.showlist(dispatch, params));
          GeneralLedgerMiddleware.alertHendler(dispatch,response,true,'Delete Data Successfully','success')
        }
      })
      .catch((error) => {
        GeneralLedgerMiddleware.alertHendler(dispatch,error,true)
      });
  }

  static saveNew(dispatch, post,search){
    axios({
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${GeneralLedgerMiddleware.getToken()}`
        },
        url: url,
        data:post,
        responseType: 'json'
      })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(GeneralLedgerActions.process(),GeneralLedgerMiddleware.showlist(dispatch,search));
          dispatch(GeneralLedgerActions.success());
          GeneralLedgerMiddleware.alertHendler(dispatch,response,true,'Create Data Successfully','success')
        }
      })
      .catch((error) => {
        GeneralLedgerMiddleware.alertHendler(dispatch,error)
      });
  }

  static saveUpdate(dispatch, params, post){
    axios({
        method: 'PUT',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: `Bearer ${GeneralLedgerMiddleware.getToken()}`
        },
        url: url+'/'+params,
        data:post,
        responseType: 'json'
      })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          // dispatch(GeneralLedgerActions.process(),GeneralLedgerActions.showlist(dispatch,search));
          // dispatch(GeneralLedgerActions.success());
          // GeneralLedgerMiddleware.alertHendler(dispatch,response,true,'Update Data Successfully','success')
        }
      })
      .catch((error) => {
        GeneralLedgerMiddleware.alertHendler(dispatch,error)
      });
  }

  static alertHendler(dispatch,result,isSwal=false,extraMessage='',type='error'){
    if(type=='error'){
      if (result.response) {
        const status=result.response.status
        switch(status){
          
          case 500:
            if(isSwal){
              const data=result.response.data
              MySwal.hideLoading()
              MySwal.update({
                title:'Delete Error',
                html:data.error,
                icon:'error',
                showConfirmButton:true,
              })
            }else{
              const data=result.response.data
              dispatch(GeneralLedgerActions.error(data.error));
            }
          break;  
          case 403:
            console.log('Error 403');
          break;     
          case 404:
            console.log('Error 404');
          break;   
          case 401:
            const data=result.response.data
              MySwal.fire({
                title:'Login Invalid',
                html:data.error,
                icon:'error',
                showConfirmButton:true,
              }).then((result)=>{
                  if(result.isConfirmed){
                    <Navigate to="/login"></Navigate>
                  }
              })
          break;   
        }
      } else if (result.request) {
        MySwal.fire({
          title:'Internal Server Error',
          html:'Please info your Developer to fix this',
          icon:'error',
          showConfirmButton:true,
        })
        dispatch(GeneralLedgerActions.reset());
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', result.message);
      }
    }else{
      MySwal.fire({
        title:'Success',
        html:extraMessage,
        icon:'success',
        showConfirmButton:true,
      })
    }
  }
}
